import { normalizeLocation } from "./msrLocations";

// LWI-1549 — new-MSR location defaults, ported from the classic Create page:
//   LWI-1143  a profile default location (user.default_location_codes) seeds Ship From
//   LWI-1378  on the US tenant, Ship From (when no profile default) and Charge To
//             default to GDLS Sterling Heights instead of the CA HCL Oxford default
// Defaults only seed the fields — the user can still change them.

export const US_TENANT = "US";

export const US_STERLING_HEIGHTS = normalizeLocation({
  locationCode: "GENESM01",
  name: "GDLS Sterling Ht",
  address1: "38500 Mound Rd",
  address2: "",
  city: "Sterling Heights",
  state: "MI",
  zip: "48310",
  country: "USA",
  open: "07:00",
  close: "16:00",
  contactName: "",
  contactPhone: "",
  contactEmail: "",
});

/** Profile default location codes on the auth user (LWI-1143). */
export const profileDefaultCodes = (user) =>
  Array.isArray(user?.default_location_codes)
    ? user.default_location_codes
    : [];

export const profileDefaultNames = (user) =>
  Array.isArray(user?.default_location_names)
    ? user.default_location_names
    : [];

/**
 * The location patch for a brand-new MSR.
 * @param {{ tenant?: string, profileShipFrom?: object|null }} args
 * @returns {{ shipFrom?: object, chargeTo?: object }}
 */
export const newMsrLocationDefaults = ({ tenant, profileShipFrom } = {}) => {
  const patch = {};
  if (profileShipFrom) patch.shipFrom = profileShipFrom;
  if (tenant === US_TENANT) {
    if (!profileShipFrom) patch.shipFrom = US_STERLING_HEIGHTS;
    patch.chargeTo = US_STERLING_HEIGHTS;
  }
  return patch;
};
